export { default } from './AuthTitle';
export * from './AuthTitle';
